'use strict';
import {createManageTaggablesState, createManageTagState} from '../data-tags/DATA_TAG_STATES';
import assetsHomeTemplate from './controllers/assets-home.html';
import assetsRootTemplate from './controllers/assets-tabs.html';
import {assetsStates} from './router-config';


routerConfig.$inject = [
  '$stateProvider',
];

export function routerConfig(
  $stateProvider,
) {
  $stateProvider
    .state(assetsStates.assetsRoot, {
      url: '/assets',
      abstract: true,
      views: {
        'appContent': {
          template: assetsRootTemplate,
          controller: 'AssetController',
        },
      },
    })

    .state(assetsStates.assetsHome, {
      title: 'assets.home.header.label',
      url: '/home',
      views: {
        'tab-assets-tasks': {
          template: assetsHomeTemplate,
          controller: 'AssetHomeController',
        },
      },
    })


    /*****************************************************************************************************************
     * Data Tags
     ****************************************************************************************************************/

    .state(assetsStates.assetsDataTagsTaggables, createManageTaggablesState({
      viewName: 'tab-assets-tasks',
      sourceName: assetsStates.assetsHome,
      manageName: assetsStates.assetsDataTagsManage,
    }))

    .state(assetsStates.assetsDataTagsManage, createManageTagState({
      viewName: 'tab-assets-tasks',
      manageTaggablesName: assetsStates.assetsDataTagsTaggables,
    }));
}



// WEBPACK FOOTER //
// ./src/js/assets/router.js